var _g, _g2, _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "48px",
    height: "48px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#792A18"
    },
    points: "253.277,144.34 253.277,177.021 307.745,177.021 318.638,160.681 307.745,144.34 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792A18"
    },
    d: "M471.149,128c-12.094,0-22.647,6.575-28.298,16.34H307.745v32.681h135.106 c5.652,9.765,16.203,16.34,28.298,16.34c18.05,0,32.681-14.631,32.681-32.681S489.199,128,471.149,128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792A18"
    },
    d: "M296.851,345.872H264.17l27.234,76.255h32.681v-49.021 C324.085,358.066,311.892,345.872,296.851,345.872z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5AC51"
    },
    d: "M264.17,345.872H100.766c-15.041,0-27.234,12.193-27.234,27.234v49.021h217.872v-49.021 C291.404,358.066,279.211,345.872,264.17,345.872z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5AC51"
    },
    points: "220.596,247.83 275.064,226.043 275.064,95.319 220.596,73.532 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5AC51"
    },
    points: "242.383,73.532 122.553,95.319 122.553,226.043 242.383,247.83 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#792A18"
    },
    points: "220.596,40.851 242.383,95.319 275.064,95.319 275.064,40.851 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.553,
    y: 40.851,
    style: {
      fill: "#792A18"
    },
    width: 119.83,
    height: 54.468
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#792A18"
    },
    points: "220.596,280.511 275.064,280.511 275.064,226.043 242.383,226.043 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.553,
    y: 226.043,
    style: {
      fill: "#F5AC51"
    },
    width: 119.83,
    height: 54.468
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792A18"
    },
    d: "M275.064,258.723h-32.681v54.468h32.681c15.041,0,27.234-12.193,27.234-27.234 C302.298,270.917,290.105,258.723,275.064,258.723z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792A18"
    },
    d: "M269.617,285.957c0-15.041-12.193-27.234-27.234-27.234h-119.83 c-15.041,0-27.234,12.193-27.234,27.234c0,15.041,12.193,27.234,27.234,27.234h119.83 C257.424,313.191,269.617,300.998,269.617,285.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792A18"
    },
    d: "M275.064,8.17h-32.681v54.468h32.681c15.041,0,27.234-12.193,27.234-27.234 S290.105,8.17,275.064,8.17z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5AC51"
    },
    d: "M269.617,35.404c0-15.041-12.193-27.234-27.234-27.234h-119.83 c-15.041,0-27.234,12.193-27.234,27.234s12.193,27.234,27.234,27.234h119.83C257.424,62.638,269.617,50.445,269.617,35.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792A18"
    },
    d: "M324.085,389.447h-32.681l54.468,114.383h32.681v-59.915 C378.553,413.833,354.167,389.447,324.085,389.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#792A18"
    },
    d: "M291.404,389.447H73.532c-30.082,0-54.468,24.386-54.468,54.468v59.915h326.808v-59.915 C345.872,413.833,321.486,389.447,291.404,389.447z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 305.021,
    cy: 430.298,
    r: 8.17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.702,
    cy: 462.979,
    r: 8.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389.447,495.66h-2.723v-51.745c0-31.769-23.779-58.07-54.468-62.088v-8.72c0-19.522-15.883-35.404-35.404-35.404H100.766 c-19.521,0-35.404,15.882-35.404,35.404v8.72c-30.689,4.018-54.468,30.319-54.468,62.088v51.745H8.17c-4.512,0-8.17,3.657-8.17,8.17 S3.658,512,8.17,512h381.277c4.512,0,8.17-3.657,8.17-8.17S393.959,495.66,389.447,495.66z M27.234,443.915 c0-25.529,20.769-46.298,46.298-46.298h32.681c4.512,0,8.17-3.657,8.17-8.17c0-4.513-3.658-8.17-8.17-8.17H81.702v-8.17 c0-10.511,8.553-19.064,19.064-19.064h196.085c10.511,0,19.064,8.553,19.064,19.064v8.17H138.894c-4.512,0-8.17,3.657-8.17,8.17 c0,4.513,3.658,8.17,8.17,8.17h185.191c25.529,0,46.298,20.769,46.298,46.298v51.745H27.234V443.915z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M471.149,119.83c-12.889,0-25.01,6.157-32.67,16.34H283.234v-32.681h2.723c4.512,0,8.17-3.657,8.17-8.17 s-3.658-8.17-8.17-8.17h-2.723V69.847c15.594-3.699,27.234-17.733,27.234-34.442C310.468,15.882,294.585,0,275.064,0H122.553 c-19.521,0-35.404,15.882-35.404,35.404c0,16.71,11.64,30.743,27.234,34.442v17.302h-2.723c-4.512,0-8.17,3.657-8.17,8.17 s3.658,8.17,8.17,8.17h2.723v114.383h-2.723c-4.512,0-8.17,3.657-8.17,8.17s3.658,8.17,8.17,8.17h2.723v17.302 c-15.594,3.699-27.234,17.733-27.234,34.442c0,19.522,15.883,35.404,35.404,35.404h152.511c19.521,0,35.404-15.882,35.404-35.404 c0-16.71-11.64-30.743-27.234-34.442v-17.302h2.723c4.512,0,8.17-3.657,8.17-8.17s-3.658-8.17-8.17-8.17h-2.723v-65.362h159.617 c2.916,0,5.611-1.555,7.071-4.077c4.378-7.565,12.511-12.263,21.227-12.263c13.516,0,24.511,10.996,24.511,24.511 s-10.995,24.511-24.511,24.511c-8.716,0-16.849-4.698-21.226-12.263c-1.46-2.523-4.155-4.077-7.071-4.077H307.745 c-4.512,0-8.17,3.657-8.17,8.17s3.658,8.17,8.17,8.17h130.734c7.66,10.183,19.781,16.34,32.67,16.34 c22.526,0,40.851-18.325,40.851-40.851S493.675,119.83,471.149,119.83z M103.489,35.404c0-10.511,8.553-19.064,19.064-19.064 h152.511c10.511,0,19.064,8.553,19.064,19.064s-8.553,19.064-19.064,19.064H122.553C112.042,54.468,103.489,45.916,103.489,35.404z M130.723,70.809h136.17v16.34h-136.17V70.809z M294.128,285.957c0,10.511-8.553,19.064-19.064,19.064H122.553 c-10.511,0-19.064-8.553-19.064-19.064c0-10.511,8.553-19.064,19.064-19.064h152.511 C285.575,266.894,294.128,275.446,294.128,285.957z M266.894,250.553h-136.17v-16.34h136.17V250.553z M130.723,217.872V103.489 h136.17v114.383H130.723z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaw);
export default __webpack_public_path__ + "static/media/law.1420527865c8cad8196dd8eef7569eb2.svg";
export { ForwardRef as ReactComponent };